(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  let observer;
  if (!reduced && 'IntersectionObserver' in window && document.documentElement.dataset.acAnimations !== 'false' && !window.Shopify?.designMode) {
    observer = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('ac-visible'); observer.unobserve(entry.target); } }), {threshold: .05});
  }
  function initialize(root = document) {
    if (observer) root.querySelectorAll('.ac-reveal:not(.ac-observed)').forEach(el => {el.classList.add('ac-observed'); observer.observe(el);});
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:block:select', event => { const details = event.target.closest('details'); if (details) details.open = true; });
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (link) {
      const url = new URL(link.href, location.href);
      if (url.origin === location.origin && url.pathname === location.pathname && url.hash === '#projeto') {
        const project = document.querySelector('details#projeto');
        if (project) { project.open = true; project.querySelector('input')?.focus({preventScroll:true}); }
      }
      if (link.closest('.ac-mobile-menu')) link.closest('details').open = false;
    }
    if (!event.target.closest('.ac-nav-drop')) document.querySelectorAll('.ac-nav-drop[open]').forEach(el => el.open = false);
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelectorAll('.ac-nav-drop[open],.ac-mobile-menu[open]').forEach(el => { el.open = false; el.querySelector('summary')?.focus(); }); });
  let cartTimer;
  const syncCount = () => {
    clearTimeout(cartTimer);
    cartTimer = setTimeout(async () => {
      try { const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {credentials:'same-origin',cache:'no-store'}); if(!res.ok)return; const cart = await res.json(); document.querySelectorAll('[data-ac-count]').forEach(el => el.textContent = cart.item_count); } catch (_) { /* Cart link remains usable offline. */ }
    }, 200);
  };
  document.addEventListener('lcdb:cart-updated',syncCount);
  document.addEventListener('cart:update',syncCount);
  document.addEventListener('cart:updated',syncCount);
  window.addEventListener('pageshow',event=>{if(event.persisted)syncCount();});
})();
